
// src/connects/user-extensions-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import combineHOC from '../helpers/combine-hoc'
import lifecycle from '../helpers/lifecycle'

export const mapStateToProps = (state)=> {
  return {
    isEnable: state.reviewSetting.isEnable
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    fetchReviewSetting: ()=> dispatch(actions.fetchReviewSetting()),
    // updateReviewSetting: ()=> dispatch(actions.updateReviewSetting()),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  ui({
    state: {
      review: true
    }
  }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/user-extensions-panel.js